import { stringify } from '@backmarket/utils/query-string/stringify'
import { urlHashToObject } from '@backmarket/utils/url/urlHashToObject'

// Namespaced so it can't collide with the many other scopes that already
// read/write their own hash params on shared pages (product-list filters,
// reviews filters, table of contents, etc.) — the hash is a global
// namespace, unlike a scope-owned query param.
export const HASH_MESSAGE_KEY = 'assistant_message'

// Strips only the seeded-message key, preserving any other scope's hash
// params that happen to share the same URL fragment (the hash is a shared
// namespace — see HASH_MESSAGE_KEY above).
export function removeSeededMessageFromHash(hash: string): string {
  const values = urlHashToObject(hash)
  delete values[HASH_MESSAGE_KEY]

  const remaining = stringify(values)

  return remaining ? `#${remaining}` : ''
}
